
// Show the loading indicator
export const showLoading = (log) => ({
    type: "SHOW_LOADING",
    log
})


// Hide the loading indicator
export const hideLoading = (log) => ({
    type: "HIDE_LOADING",
    log
})


// Show a modal message
export const showMessage = (title, body, dangerous, callback = null) => ({
    type: "SHOW_MESSAGE",
    message:{
        title,
        body,
        dangerous,
        callback
    }
})

// Hide the current modal message
export const hideMessage = () => ({
    type: "HIDE_MESSAGE"
})


export default {
    showLoading,
    hideLoading,
    showMessage,
    hideMessage
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/status/status-actions.ts